import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from "react-router-dom";
import ReactLoading from 'react-loading';
import styles from "./instance.module.scss"
import icon from "images/instance_icon.png"

const Instance = (props) => {
  const [phoneVideoLoad, setPhoneVideoLoad] = useState(false);
  const [laptopVideoLoad, setLaptopVideoLoad] = useState(false);
  const [changeDevice, setChangeDevice] = useState(false);
  const [instanceData, setInstanceData] = useState();
  let { id } = useParams();
  let location = useLocation();
  useEffect(() => {
    if (instanceData) {
      if (instanceData[5].trim() === 'mobile_desktop') {
        phoneVideo()
        laptopVideo()
      } else if (instanceData[5].trim() === 'desktop') {
        laptopVideo()
      } else {
        phoneVideo()
      }
    }
    if (props.data) {
      const data = props.data.filter(instance => instance[0] === id)
      setInstanceData(data[0]);
    }
  }, [id, instanceData, props.data]);
  const titleRender = () => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return instanceData[2]
      default:
        return instanceData[1]
    }
  }
  const layoutRender = () => {
    const layoutArray = props.layouts.find((layout) => {
      return layout[0] === instanceData[3]
    });
    switch (props.searchParams.get("lang")) {
      case 'en':
        return layoutArray[2]
      default:
        return layoutArray[1]
    }
  }
  const industryRender = () => {
    const industryArray = props.industries.find((industry) => {
      return industry[0] === instanceData[4]
    });
    switch (props.searchParams.get("lang")) {
      case 'en':
        return industryArray[2]
      default:
        return industryArray[1]
    }
  }
  const introduceRender = () => {
    const layoutArray = props.layouts.find((layout) => {
      return layout[0] === instanceData[3]
    });
    switch (props.searchParams.get("lang")) {
      case 'en':
        return layoutArray[12]
      default:
        return layoutArray[11]
    }
  }
  const modalLinkRender = () => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return `/instance/modal/${id}/?lang=en`
      default:
        return `/instance/modal/${id}`
    }
  }
  const phoneVideo = () => {
    const video = document.getElementById('phoneVideo');
    video.addEventListener('loadeddata', function () {
      setPhoneVideoLoad(true)
    }, false);
  }
  const laptopVideo = () => {
    const video = document.getElementById('laptopVideo');
    video.addEventListener('loadeddata', function () {
      setLaptopVideoLoad(true)
    }, false);
  }
  return (!instanceData || !props.data) ?
    (
      <main id='instance' className={styles.instance}>
        <div className={styles.container}>
          <div className={styles.loadingWrapper}>
            <ReactLoading type="bubbles" color="#5A24FF" height={'10%'} width={'10%'} />
            <Link
              id="link"
              to={modalLinkRender()}
              state={{ background: location }}>
              <img alt='icon' src={icon} />
            </Link>
          </div>
        </div>
      </main>
    ) :
    (
      <main id='instance' className={styles.instance}>
        <div className={styles.container}>
          <div className={styles.leftContainer}>
            {instanceData[5].trim() === 'mobile_desktop' ? (
              <>
                <div id="laptopWrapper" className={`${styles.laptopWrapper} ${styles.notShow}`}>
                  <video id="laptopVideo" muted playsInline loop autoPlay preload="auto" src={instanceData[9]} />
                  {laptopVideoLoad ? null : <ReactLoading type="spinningBubbles" color="#5A24FF" height={'15%'} width={'15%'} />}
                </div>
                <div id="phoneWrapper" className={styles.phoneWrapper}>
                  <video id="phoneVideo" muted playsInline loop autoPlay preload="auto" src={instanceData[7]} />
                  {phoneVideoLoad ? null : <ReactLoading type="spinningBubbles" color="#5A24FF" height={'20%'} width={'20%'} />}
                </div>
              </>) :
              (instanceData[5].trim() === 'desktop' ?
                <div className={styles.laptopWrapper}>
                  <video id="laptopVideo" muted playsInline loop autoPlay preload="auto" src={instanceData[9]} />
                  {laptopVideoLoad ? null : <ReactLoading type="spinningBubbles" color="#5A24FF" height={'15%'} width={'15%'} />}
                </div> :
                <div className={styles.phoneWrapper}>
                  <video id="phoneVideo" muted playsInline loop autoPlay preload="auto" src={instanceData[7]} />
                  {phoneVideoLoad ? null : <ReactLoading type="spinningBubbles" color="#5A24FF" height={'20%'} width={'20%'} />}
                </div>
              )}
            {/* <div className={styles.bottom}>
              {instanceData[5].trim() === 'desktop' || (instanceData[5].trim() === 'mobile_desktop' && changeDevice) ?
                <a href={instanceData[10]} target="_blank" rel="noreferrer">
                  <button>View Demo</button>
                </a> :
                <a href={instanceData[8]} target="_blank" rel="noreferrer">
                  <button>View Demo</button>
                </a>
              }
            </div> */}
          </div>
          <div className={styles.rightContainer}>
            <div className={styles.textBox}>
              <p className={styles.title}>{titleRender()}</p>
              <p className={styles.type}>{industryRender()}</p>
              <p className={styles.hrStyle}></p>
              <div className={styles.templateName}>
                <p>{layoutRender()}</p>
              </div>
            </div>
            {instanceData[5].trim() === 'mobile_desktop' ?
              <div className={styles.switchIconDiv}>
                <div className={styles.switchButton}>
                  <input className={styles.checkbox} onChange={(e) => {
                    setChangeDevice(e.target.checked);
                    const laptop = document.querySelector('#laptopWrapper');
                    const phone = document.querySelector('#phoneWrapper');
                    if (changeDevice) {
                      laptop.style.display = 'none';
                      phone.style.display = 'block';
                    } else {
                      laptop.style.display = 'block';
                      phone.style.display = 'none';
                    }
                  }} type="checkbox" />
                  <label className={styles.label} htmlFor="">
                    <span className={styles.span}>Mobile</span>
                  </label>
                </div>
              </div> :
              <div />
            }
            <div className={styles.introduce}>
              <p>{introduceRender()}</p>
            </div>
            <div className={styles.bottomContainer}>
            <div className={styles.bottom}>
              {instanceData[5].trim() === 'desktop' || (instanceData[5].trim() === 'mobile_desktop' && changeDevice) ?
                <a href={instanceData[10]} target="_blank" rel="noreferrer">
                  <button>Demo</button>
                </a> :
                <a href={instanceData[8]} target="_blank" rel="noreferrer">
                  <button>Demo</button>
                </a>
              }
              <Link
                id="link"
                to={modalLinkRender()}
                state={{ background: location }}>
                <button>{props.searchParams.get("lang") === 'en' ? 'Spec' : '版型規格'}</button>
              </Link>
            </div>
            </div>
          </div>
        </div>
      </main>
    )
}
export default Instance